import request from '@/utils/request'

export function listParking99TempOrders(params) {
  return request({
    url: '/parking99.listTempOrders',
    method: 'get',
    params
  }).then(response => response.data)
}
